import { render, staticRenderFns } from "./Antarctica.vue?vue&type=template&id=46c19bde&"
import script from "./Antarctica.vue?vue&type=script&lang=js&"
export * from "./Antarctica.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports